<div *ngIf="
    vehicleConfigService.configuration.view.showOnMap.visible ||
    vehicleConfigService.configuration.view.showByOperation.visible ||
    vehicleConfigService.configuration.view.showOnlyVisible.visible
  ">
  <ng-container *ngIf="vehicleConfigService.configuration.view.showOnMap.visible">
    <app-checkbox-vehicle
      idCheckbox="follow-vehicles"
      [descriptionCheckBoxOff]="'VEHICLES.TOGGLE_VIEW.SHOW' | translate"
      [descriptionCheckBoxOn]="'VEHICLES.TOGGLE_VIEW.HIDE' | translate"
      [isChecked]="isCheckedFollowVehicles"
      (checkboxState)="toggleCheckFollowVehicles($event)"
    ></app-checkbox-vehicle>
  </ng-container>

  <ng-container *ngIf="vehicleConfigService.configuration.view.showByOperation.visible">
    <app-checkbox-vehicle
      idCheckbox="formated-operation"
      [descriptionCheckBoxOff]="'VEHICLES.TOGGLE_VIEW.VIEW_OPERATION' | translate"
      [descriptionCheckBoxOn]="'VEHICLES.TOGGLE_VIEW.VIEW_UNIT' | translate"
      [isChecked]="isCheckedFormatedOperation"
      (checkboxState)="toggleCheckFormatedOperation($event)"
    ></app-checkbox-vehicle>
  </ng-container>

  <ng-container *ngIf="vehicleConfigService.configuration.view.showOnlyVisible.visible">
    <app-checkbox-vehicle
      idCheckbox="filter-eye"
      descriptionCheckBoxOff="Solo visibles"
      descriptionCheckBoxOn="Todos"
      [isChecked]="isCheckedFilterEye"
      (checkboxState)="toggleCheckFilterEye($event)"
    ></app-checkbox-vehicle>
  </ng-container>
</div>
